import { FC, PropsWithChildren } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

const linkStyles = css`
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  text-decoration: none;
  color: ${(p) => p.color || p.theme.linkText};

  &:not([disabled]):hover {
    text-decoration: underline;
  }
`
const StyledLink = styled.a`
  ${linkStyles}
`

const StyledRouterLink = styled(RouterLink)`
  ${linkStyles}
`

type LinkProps = PropsWithChildren<{
  href?: string
  [key: string]: any
}>

const Link: FC<LinkProps> = ({ href, children, ...rest }) =>
  href ? (
    <StyledLink href={href} target='_blank' rel='noopener noreferrer' {...rest}>
      {children}
    </StyledLink>
  ) : (
    <StyledRouterLink {...rest}>{children}</StyledRouterLink>
  )

export default Link
